/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminBillItem1
 */
export interface AdminBillItem1 {
    /**
     * 账单ID
     * @type {number}
     * @memberof AdminBillItem1
     */
    id?: number;
    /**
     * 用户ID
     * @type {number}
     * @memberof AdminBillItem1
     */
    userId?: number;
    /**
     * 账单类型
     * @type {number}
     * @memberof AdminBillItem1
     */
    billType?: number;
    /**
     * 账单状态
     * @type {number}
     * @memberof AdminBillItem1
     */
    status?: number;
    /**
     * 汇款人（持卡人姓名）
     * @type {string}
     * @memberof AdminBillItem1
     */
    cardHolderName?: string;
    /**
     * 卡号
     * @type {string}
     * @memberof AdminBillItem1
     */
    cardNumber?: string;
    /**
     * 会员名
     * @type {string}
     * @memberof AdminBillItem1
     */
    userName?: string;
    /**
     * 会员编号
     * @type {string}
     * @memberof AdminBillItem1
     */
    userCode?: string;
    /**
     * 钱包转账总金额
     * @type {number}
     * @memberof AdminBillItem1
     */
    totalTransferAmount?: number;
    /**
     * 卡类型
     * @type {number}
     * @memberof AdminBillItem1
     */
    cardType?: number;
    /**
     * 卡所在银行名称
     * @type {string}
     * @memberof AdminBillItem1
     */
    cardBankName?: string;
    /**
     * 创建时间
     * @type {string}
     * @memberof AdminBillItem1
     */
    createTime?: string;
    /**
     * 仓库ID（订单创建账单时归属的仓库；钱包操作类账单为空）
     * @type {number}
     * @memberof AdminBillItem1
     */
    warehouseId?: number;
}

/**
 * Check if a given object implements the AdminBillItem1 interface.
 */
export function instanceOfAdminBillItem1(value: object): value is AdminBillItem1 {
    return true;
}

export function AdminBillItem1FromJSON(json: any): AdminBillItem1 {
    return AdminBillItem1FromJSONTyped(json, false);
}

export function AdminBillItem1FromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminBillItem1 {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'billType': json['billType'] == null ? undefined : json['billType'],
        'status': json['status'] == null ? undefined : json['status'],
        'cardHolderName': json['cardHolderName'] == null ? undefined : json['cardHolderName'],
        'cardNumber': json['cardNumber'] == null ? undefined : json['cardNumber'],
        'userName': json['userName'] == null ? undefined : json['userName'],
        'userCode': json['userCode'] == null ? undefined : json['userCode'],
        'totalTransferAmount': json['totalTransferAmount'] == null ? undefined : json['totalTransferAmount'],
        'cardType': json['cardType'] == null ? undefined : json['cardType'],
        'cardBankName': json['cardBankName'] == null ? undefined : json['cardBankName'],
        'createTime': json['createTime'] == null ? undefined : json['createTime'],
        'warehouseId': json['warehouseId'] == null ? undefined : json['warehouseId'],
    };
}

export function AdminBillItem1ToJSON(json: any): AdminBillItem1 {
    return AdminBillItem1ToJSONTyped(json, false);
}

export function AdminBillItem1ToJSONTyped(value?: AdminBillItem1 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'userId': value['userId'],
        'billType': value['billType'],
        'status': value['status'],
        'cardHolderName': value['cardHolderName'],
        'cardNumber': value['cardNumber'],
        'userName': value['userName'],
        'userCode': value['userCode'],
        'totalTransferAmount': value['totalTransferAmount'],
        'cardType': value['cardType'],
        'cardBankName': value['cardBankName'],
        'createTime': value['createTime'],
        'warehouseId': value['warehouseId'],
    };
}

